import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { AiAssistantApiConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class AiAssistantApiModule {
    public static forRoot(configurationFactory: () => AiAssistantApiConfiguration): ModuleWithProviders<AiAssistantApiModule> {
        return {
            ngModule: AiAssistantApiModule,
            providers: [ { provide: AiAssistantApiConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: AiAssistantApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('AiAssistantApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
